/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Login from './Login';
import './LoginPageVoyra.scss';
import AppLink from '../../shared/components/app-link/AppLink';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import { useAppContext } from '../../saas/AppConfigWrapper';
import {
  getStringFromLS,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import { APP_LOGO_URL } from '../../saas/AppStorageStaticNames';
import LoginVoyra from './LoginVoyra';

function LoginPageVoyra() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(NAVIGATION_ROUTES.AGENT_REGISTRATION);
  };

  const getPortFolioLink = () => {
    try {
      const servicesLinks = getValueFromAppConfig('SAAS_APP_SERVICES_LINK')
        .split(',')
        .reduce((acc, cur) => {
          acc.push({
            service: cur.split('@@@')[0],
            link: cur.split('@@@')[1],
          });
          return acc;
        }, []);
      const portfolioService = servicesLinks.find(
        (x) => x.service === 'portfolio',
      );
      return portfolioService ? portfolioService.link : '';
    } catch (error) {
      return '';
    }
  };

  return (
    <div className="vg-page">
      {/* ── NAV ── */}
      <nav className="vg-nav">
        <button className="vg-logo" type="button" onClick={() => navigate('/')}>
          {getStringFromLS(APP_LOGO_URL) ? (
            <img
              src={getStringFromLS(APP_LOGO_URL)}
              alt={appConfig.companyName}
              style={{ maxHeight: `${appConfig.logoHeight || 44}px` }}
            />
          ) : (
            <>
              <span className="vg-logo-v">V</span>
              <span className="vg-logo-name">{appConfig.companyName}</span>
            </>
          )}
        </button>

        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
          {appConfig.helpline24 && (
            <a
              href={`tel:${appConfig.supportNumber}`}
              style={{
                textDecoration: 'none',
                color: '#235f5e',
                fontWeight: 600,
                fontSize: 13,
              }}
              className="hide-in-mobile"
            >
              📞 {appConfig.supportNumber}
            </a>
          )}
          {appConfig.hasPortfolio && (
            <AppLink
              variant="primary"
              isLink
              href={getPortFolioLink()}
              target="_blank"
              linkText="Portfolio"
            />
          )}
          <button
            type="button"
            className="vg-nav-register"
            onClick={handleClick}
          >
            Register Agency
          </button>
          <button
            type="button"
            className="vg-nav-register"
            onClick={() => navigate('/contact-us')}
          >
            Support
          </button>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section className="vg-hero">
        {/* Left: overlapping gallery */}
        <div className="vg-gallery hide-in-mobile">
          <div className="vg-gallery-item vg-gi-1">
            <img
              src={`${appConfig?.appMainUrl}bannerimg/${appConfig?.appDbName}_indexindex1.jpg`}
              alt="Travel"
            />
          </div>
          <div className="vg-gallery-item vg-gi-2">
            <img
              src={`${appConfig?.appMainUrl}bannerimg/${appConfig?.appDbName}_indexindex3.jpg`}
              alt="Destination"
            />
          </div>
          <div className="vg-gallery-item vg-gi-3">
            <img
              src={`${appConfig?.appMainUrl}bannerimg/${appConfig?.appDbName}_indexindex2.jpg`}
              alt="Hotel"
            />
          </div>
        </div>

        {/* Right: heading + login card */}
        <div className="vg-hero-right">
          <div>
            <h1 className="vg-hero-title">
              {appConfig.companyName}
              <br />
              <span className="vg-hero-accent">B2B Gateway.</span>
            </h1>
            <p className="vg-hero-desc">
              Access the most powerful B2B travel ecosystem. Real-time GDS
              aviation feeds and direct wholesale hotel inventory for verified
              travel agencies and independent professionals.
            </p>
          </div>

          <div>
            <LoginVoyra />
          </div>
        </div>
      </section>

      {/* ── WHY SECTION ── */}
      <section className="vg-why">
        <div className="vg-why-header">
          <h2>Why {appConfig?.companyName}?</h2>
          <p>
            {appConfig?.companyName} will help you unlock journeys and become
            your key to limitless travel possibilities.
          </p>
        </div>
        <div className="vg-why-grid">
          {[
            {
              img: 'https://cdn-icons-png.flaticon.com/512/2489/2489756.png',
              alt: 'Rates',
              title: 'Best Ever Rates',
              desc: 'Exclusive rates tailored for our partners, ensuring cost-effective solutions across all bookings.',
            },
            {
              img: 'https://cdn-icons-png.flaticon.com/512/1063/1063376.png',
              alt: 'Support',
              title: 'Express Care',
              desc: 'Utilize easy-to-use tools for quick query resolutions and dedicated partner support.',
            },
            {
              img: 'https://cdn-icons-png.flaticon.com/512/1161/1161388.png',
              alt: 'Security',
              title: 'Confidentiality Assured',
              desc: 'Complete confidentiality of customer details and bookings through our secure portal.',
            },
            {
              img: 'https://cdn-icons-png.flaticon.com/512/2103/2103633.png',
              alt: 'Tech',
              title: 'Cutting-Edge Technology',
              desc: 'Streamline the booking process with our high-speed API to make it user-friendly.',
            },
          ].map(({ img, alt, title, desc }) => (
            <div className="vg-why-card" key={title}>
              <img src={img} alt={alt} />
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── COUNTER ── */}
      <section className="vg-counter">
        {[
          { value: '900+', label: 'Airlines' },
          { value: '1.2M', label: 'Hotels' },
          { value: '150+', label: 'Countries' },
          { value: '24/7', label: 'Support' },
        ].map(({ value, label }) => (
          <div className="vg-counter-item" key={label}>
            <h2>{value}</h2>
            <p>{label}</p>
          </div>
        ))}
      </section>

      {/* ── FOOTER ── */}
      <footer className="vg-footer">
        <div className="vg-footer-grid">
          <div className="vg-footer-col">
            <div style={{ marginBottom: 16 }}>
              <div
                style={{
                  fontFamily: "'Playfair Display', serif",
                  fontSize: 24,
                  color: '#fff',
                  lineHeight: 1,
                }}
              >
                V
              </div>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: '#fff',
                  letterSpacing: 3,
                  textTransform: 'uppercase',
                }}
              >
                {appConfig.companyName}
              </div>
            </div>
            <p
              style={{
                fontSize: '0.83rem',
                opacity: 0.5,
                lineHeight: 1.6,
                margin: 0,
              }}
            >
              The world&apos;s most advanced B2B ecosystem for travel
              professionals.
            </p>
          </div>

          <div className="vg-footer-col">
            <h4>Quick Links</h4>
            <ul className="vg-footer-links">
              <li>
                <a href="/search">Flight Search</a>
              </li>
              <li>
                <a href="/hotel/search">Hotel Inventory</a>
              </li>
              <li>
                <a href="/my-bookings">My Bookings</a>
              </li>
              <li>
                <a href="/agent-registration">Partner Program</a>
              </li>
            </ul>
          </div>

          <div className="vg-footer-col">
            <h4>Company</h4>
            <ul className="vg-footer-links">
              <li>
                <a href="/about-us">About Us</a>
              </li>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms-conditions">Terms of Use</a>
              </li>
              <li>
                <a href="/contact-us">Contact Support</a>
              </li>
            </ul>
          </div>

          <div className="vg-footer-col">
            <h4>Get In Touch</h4>
            {appConfig.supportNumber && (
              <a
                href={`tel:${appConfig.supportNumber}`}
                style={{
                  color: '#888',
                  textDecoration: 'none',
                  fontSize: '0.88rem',
                  display: 'block',
                }}
              >
                📞 {appConfig.supportNumber}
              </a>
            )}
          </div>
        </div>

        <div className="vg-footer-bottom">
          <p>
            © {new Date().getFullYear()} {appConfig.companyName}. All Rights
            Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default LoginPageVoyra;
